'use client';

import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';

/**
 * Popup lab gate: the owner preview of the v2 exit popup, on every page, including leadpops.com. Costs normal visitors
 * one tiny effect and nothing else; the new popup and the lab bar are a separate chunk that only loads with the flag.
 *   ?popup=new   turn the lab on (remembered for this tab only, so it follows you from page to page)
 *   ?popup=off   turn it off
 * While the lab is on, the current live popup is switched off in this tab (GlobalWidgets checks isPopupLabOn).
 */
const Panel = dynamic(() => import('./PopupLabPanel'), { ssr: false });
const KEY = 'popuplab.on';

export function isPopupLabOn(): boolean {
  try {
    const q = new URLSearchParams(window.location.search).get('popup');
    if (q === 'new') return true;
    if (q === 'off') return false;
    return sessionStorage.getItem(KEY) === '1';
  } catch { return false; }
}

export function PopupLabGate() {
  const [on, setOn] = useState(false);
  useEffect(() => {
    try {
      const q = new URLSearchParams(window.location.search).get('popup');
      if (q === 'new') sessionStorage.setItem(KEY, '1');
      else if (q === 'off') sessionStorage.removeItem(KEY);
    } catch { /* storage blocked: lab works for this page only */ }
    setOn(isPopupLabOn());
  }, []);
  if (!on) return null;
  return <Panel onExit={() => { try { sessionStorage.removeItem(KEY); } catch { /* ignore */ } window.location.href = window.location.pathname; }} />;
}
